import { render, staticRenderFns } from "./Lessons.vue?vue&type=template&id=607a8842&scoped=true&"
import script from "./Lessons.vue?vue&type=script&lang=js&"
export * from "./Lessons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607a8842",
  null
  
)

export default component.exports